import { useState } from "react";
import { BackofficeLogin } from "@/components/backoffice/BackofficeLogin";
import { BackofficeShell } from "@/components/backoffice/BackofficeShell";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Backoffice() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [token, setToken] = useState("");

  const handleLogin = async (email, password) => {
    try {
      const r = await fetch(`${API}/api/backoffice/login`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      if (!r.ok) return false;
      const d = await r.json();
      setToken(d.token);
      setUserEmail(email);
      setIsAuthenticated(true);
      return true;
    } catch {
      return false;
    }
  };

  if (!isAuthenticated) {
    return <BackofficeLogin onLogin={handleLogin} />;
  }
  return <BackofficeShell userEmail={userEmail} token={token} onLogout={() => { setIsAuthenticated(false); setUserEmail(""); setToken(""); }} />;
}
